import { CSSProperties } from "react";

import { constants, spacing, theme } from "../../../layout";

export const styles: Record<string, CSSProperties> = {
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  codeInputContainer: {
    justifyContent: "center",
    alignItems: "center",
    height: 62,
    width: 48,
    borderRadius: constants.radius.view,
    marginLeft: spacing.xxs,
    marginRight: spacing.xxs,
    backgroundColor: theme.input.background,
  },
  codeInput: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    textAlign: "center",
    fontSize: 22,
  },
  hidden: {
    opacity: 0,
  },
};
